/**
 *    Shariff
 */

(function ($) {
  Drupal.behaviors.shariff = {
    attach() {
      // a11y - wait for elements ...
      setTimeout(() => {
        const $sharrifContainer = $('.shariff');

        // ... remove role attribute
        $sharrifContainer
          .find('[role="button"]')
          .removeAttr('role');

        // ... add aria attributes
        $sharrifContainer
          .find('.fab')
          .attr('aria-hidden', 'true');

        // ... remove share text (aria-label is enough)
        $sharrifContainer
          .find('.share_text')
          .remove();
      }, 2000);
    },
  };
}(jQuery));
